import { Directive, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';

@Directive({
    selector: '[appDragAndDrop]',
})
export class DragAndDropDirective implements OnDestroy {
    @Output() fileDropped = new EventEmitter<Event>();
    fileInput: HTMLInputElement;

    constructor() {
        this.fileInput = document.createElement('input');
        this.fileInput.hidden = true;
        this.fileInput.type = 'file';
        document.body.append(this.fileInput);
        this.fileInput.addEventListener('change', (ev) => this.fileDropped.emit(ev));
    }

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    // Drop listener
    @HostListener('drop', ['$event']) onDrop(event) {
        event.preventDefault();
        event.stopPropagation();

        if (event?.dataTransfer?.files?.length > 0) {
            this.fileInput.files = event.dataTransfer.files;
            const changeEvent = new Event('change');
            this.fileInput.dispatchEvent(changeEvent);
        }
    }

    ngOnDestroy(): void {
        this.fileInput?.remove();
    }
}
